import React from 'react'
import PropTypes from 'prop-types'
import { Form, Input, Switch } from 'antd'
import { SelectF, RadioButtonF } from '@/i2antdV5'

const FormItem = Form.Item
const { TextArea } = Input

/** 新建模板时默认渠道：取 NotificationChannel 枚举首项 */
function defaultNotificationChannelId (channelOptions = []) {
  return channelOptions.length > 0 ? channelOptions[0].id : undefined
}

class ServiceNotificationForm extends React.Component {
  static propTypes = {
    editingTemplate: PropTypes.object,
    form: PropTypes.object,
    templateTypeOptions: PropTypes.array,
    channelOptions: PropTypes.array
  }

  static defaultProps = {
    templateTypeOptions: [],
    channelOptions: []
  }

  componentDidMount () {
    const { form, editingTemplate, channelOptions } = this.props
    if (form && form.current) {
      if (editingTemplate) {
        const formValues = {
          templateName: editingTemplate.templateName,
          templateType: editingTemplate.templateType,
          title: editingTemplate.title,
          content: editingTemplate.content,
          channel: editingTemplate.channel,
          enabled: editingTemplate.enabled !== undefined ? editingTemplate.enabled : true,
          description: editingTemplate.description || ''
        }
        form.current.setFieldsValue(formValues)
      } else {
        form.current.setFieldsValue({
          enabled: true,
          channel: defaultNotificationChannelId(channelOptions)
        })
      }
    }
  }

  componentDidUpdate (prevProps) {
    const { form, editingTemplate, channelOptions } = this.props
    if (form && form.current && editingTemplate && prevProps.editingTemplate !== editingTemplate) {
      const formValues = {
        templateName: editingTemplate.templateName,
        templateType: editingTemplate.templateType,
        title: editingTemplate.title,
        content: editingTemplate.content,
        channel: editingTemplate.channel,
        enabled: editingTemplate.enabled !== undefined ? editingTemplate.enabled : true,
        description: editingTemplate.description || ''
      }
      form.current.setFieldsValue(formValues)
    }
    if (form && form.current && !editingTemplate && prevProps.editingTemplate) {
      form.current.resetFields()
      form.current.setFieldsValue({
        enabled: true,
        channel: defaultNotificationChannelId(channelOptions)
      })
    }
    if (
      form &&
      form.current &&
      !editingTemplate &&
      channelOptions.length > 0 &&
      prevProps.channelOptions.length === 0
    ) {
      const cur = form.current.getFieldValue('channel')
      if (cur === undefined || cur === null || cur === '')
        form.current.setFieldsValue({ channel: channelOptions[0].id })
    }
  }

  render () {
    const { form, templateTypeOptions, channelOptions } = this.props

    return (
      <Form
        ref={form}
        layout="vertical"
        labelCol={{ span: 24 }}
        wrapperCol={{ span: 24 }}
      >
        <FormItem
          label="模板名称"
          name="templateName"
          rules={[
            { required: true, message: '请输入模板名称' },
            { max: 50, message: '模板名称不能超过50个字符' }
          ]}
        >
          <Input placeholder="请输入模板名称" />
        </FormItem>

        <FormItem
          label="模板类型"
          name="templateType"
          rules={[{ required: true, message: '请选择模板类型' }]}
        >
          <SelectF
            options={templateTypeOptions}
            modalProps={{ placeholder: '请选择模板类型' }}
          />
        </FormItem>

        <FormItem
          label="通知标题"
          name="title"
          rules={[
            { required: true, message: '请输入通知标题' },
            { max: 100, message: '通知标题不能超过100个字符' }
          ]}
        >
          <Input placeholder="请输入通知标题" />
        </FormItem>

        <FormItem
          label="通知内容"
          name="content"
          rules={[
            { required: true, message: '请输入通知内容' },
            { max: 500, message: '通知内容不能超过500个字符' }
          ]}
        >
          <TextArea
            rows={4}
            placeholder="请输入通知内容，支持变量如：{serviceTime}、{employeeName}等"
          />
        </FormItem>

        <FormItem
          label="通知渠道"
          name="channel"
          rules={[{ required: true, message: '请选择通知渠道' }]}
        >
          <RadioButtonF
            options={channelOptions}
          />
        </FormItem>

        <FormItem
          label="是否启用"
          name="enabled"
          valuePropName="checked"
        >
          <Switch checkedChildren="启用" unCheckedChildren="禁用" />
        </FormItem>

        <FormItem
          label="模板描述"
          name="description"
          rules={[{ max: 200, message: '模板描述不能超过200个字符' }]}
        >
          <TextArea
            rows={2}
            placeholder="请输入模板描述（可选）"
          />
        </FormItem>
      </Form>
    )
  }
}

export default ServiceNotificationForm
